import angular from 'angular';
import uiRouter from 'angular-ui-router';
import unitComponent from './unit.component';
import unitAuthenticationGoogleComponent from './unit-authentication-google.component';
import unitListComponent from './unit-list.component';
import unitDetailComponent from './unit-detail.component';
import UnitService from './unit.service';
import UnitDetailService from './unit-detail.service';
import TimeTitleService from '../title-time/time-title.service'

let unitModule = angular.module('unit', [
  uiRouter
])

.service('Unit', UnitService)
.service('UnitDetail', UnitDetailService)
.service('TimeTitleService', TimeTitleService)

.config(($stateProvider) => {
  "ngInject";

  $stateProvider
    .state('unit', {
      component: 'unit'
    })
    .state('unit.list', {
      url: '/unit',
      component: 'unitList'
    })
    .state('unit.create', {
      url: '/unit/new',
      component: 'unitDetail',
      params: {
        id: ""
      }
    })
    .state('unit.edit', {
      url: '/unit/:id/edit',
      component: 'unitDetail',
      params: {
        id: ""
      }
    })
    .state('unit.authentication', {
      url: '/unit/authentication',
      component: 'unitAuthenticationGoogle'
    });
})

.component('unit', unitComponent)
.component('unitList', unitListComponent)
.component('unitDetail', unitDetailComponent)
.component('unitAuthenticationGoogle', unitAuthenticationGoogleComponent)

.name;

export default unitModule;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit.js